import type { ShopDto, UpdateOneShopWebhookDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateWebhook(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);
	return useApiMutation("patch", "/shops/{shopId}/webhooks/{webhookId}", {
		invalidate: invalidateShop,
		mapVariables: (body: UpdateOneShopWebhookDto) => ({
			params: { path: { shopId: shop.id, webhookId: body.id! } },
			body,
		}),
	});
}
